export const OEM_SCAN_CONSTANTS = {
  FETCH_OEM_SCANS_REQUEST: "FETCH_OEM_SCANS_REQUEST",
  FETCH_OEM_SCANS_SUCCESS: "FETCH_OEM_SCANS_SUCCESS",
  FETCH_OEM_SCANS_FAILURE: "FETCH_OEM_SCANS_FAILURE",
};